export const MODULES = {
  DASHBOARD: "dashboard",
  AI_HUB: "aihub",
  CHAT: "chat",
  DOC_FINDER: "docfinder",
  HISTORY: "history",
  COMPLIANCE: "compliance",
  QNA: "qna",
  ADMIN_REPLY: "adminReply",
  USAGE: "usage",
  USERS: "users",
  CONSISTENCY_GUARD: "consistencyGuard",
  ONBOARDING_COPILOT: "onboardingCopilot",
  KG_CHAT: "kgchat",
  NL2GRAPH: "nl2graph",
  AI_ADOPTION: "aiAdoption",
  SETTINGS: "settings",
} as const;

export type ModuleName = typeof MODULES[keyof typeof MODULES];
